import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithHeaders } from './baseApi';

export interface MessageInterne {
  id: number;
  expediteur: number;
  expediteur_nom: string;
  destinataire: number;
  destinataire_nom: string;
  type_message: 'info' | 'important' | 'urgent' | 'felicitation' | 'rappel';
  type_display: string;
  sujet: string;
  contenu: string;
  lu: boolean;
  date_lecture: string | null;
  date_envoi: string;
  est_broadcast: boolean;
}

export const messagerieApi = createApi({
  reducerPath: 'messagerieApi',
  baseQuery: baseQueryWithHeaders,
  tagTypes: ['Messages'],
  endpoints: (builder) => ({
    getMessages: builder.query<MessageInterne[], Record<string, any> | void>({
      query: (params) => ({ url: '/messages/', params: params ?? undefined }),
      transformResponse: (r: any) => Array.isArray(r) ? r : r?.results || [],
      providesTags: ['Messages'],
    }),

    getNonLus: builder.query<{ count: number; messages: MessageInterne[] }, void>({
      query: () => '/messages/non_lus/',
      providesTags: ['Messages'],
    }),

    envoyerMessage: builder.mutation<{ success: boolean; nb_envoyes: number; message: string }, {
      destinataire_ids?: number[];
      destinataire?: number;
      broadcast?: boolean;
      sujet: string;
      contenu: string;
      type_message?: string;
    }>({
      query: (data) => ({ url: '/messages/envoyer/', method: 'POST', body: data }),
      invalidatesTags: ['Messages'],
    }),

    marquerLu: builder.mutation<{ success: boolean }, number>({
      query: (id) => ({ url: `/messages/${id}/marquer_lu/`, method: 'POST' }),
      invalidatesTags: ['Messages'],
    }),

    marquerTousLus: builder.mutation<{ success: boolean; nb: number }, void>({
      query: () => ({ url: '/messages/marquer_tous_lus/', method: 'POST' }),
      invalidatesTags: ['Messages'],
    }),

    deleteMessage: builder.mutation<void, number>({
      query: (id) => ({ url: `/messages/${id}/`, method: 'DELETE' }),
      invalidatesTags: ['Messages'],
    }),
  }),
});

export const {
  useGetMessagesQuery,
  useGetNonLusQuery,
  useEnvoyerMessageMutation,
  useMarquerLuMutation,
  useMarquerTousLusMutation,
  useDeleteMessageMutation,
} = messagerieApi;
